export enum ELocalPrestacaoServico
{
    Tomador = 0,
    Prestador = 1,
}
